class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    clearTimeout(this.closeTimer);
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverMedia = window.matchMedia('(min-width: 990px)');
    this.openOnHover = this.openOnHover.bind(this);
    this.closeOnLeave = this.closeOnLeave.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onSummaryClick = this.onSummaryClick.bind(this);
    this.onHoverMediaChange = this.onHoverMediaChange.bind(this);

    this.querySelector('summary').addEventListener('click', this.onSummaryClick);
    const parentNavLink = this.querySelector('[data-mega-link]');
    if (parentNavLink) {
      parentNavLink.addEventListener('click', (event) => {
        if (!this.hoverMedia.matches) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const url = parentNavLink.getAttribute('data-mega-link');
        if (url) window.location.assign(url);
      });
    }
    this.onHoverMediaChange(this.hoverMedia);
    if (this.hoverMedia.addEventListener) {
      this.hoverMedia.addEventListener('change', this.onHoverMediaChange);
    } else if (this.hoverMedia.addListener) {
      this.hoverMedia.addListener(this.onHoverMediaChange);
    }
  }

  onHoverMediaChange(media) {
    const desktop = media.matches;
    this.removeEventListener('mouseenter', this.openOnHover);
    this.removeEventListener('mouseleave', this.closeOnLeave);
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('keydown', this.onKeyDown);

    if (!desktop) return;

    this.addEventListener('mouseenter', this.openOnHover);
    this.addEventListener('mouseleave', this.closeOnLeave);
    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keydown', this.onKeyDown);
  }

  onSummaryClick(event) {
    if (!this.hoverMedia.matches) return;
    if (event.detail === 0) return;
    event.preventDefault();
  }

  openOnHover() {
    clearTimeout(this.closeTimer);
    document.querySelectorAll('header-menu details[open]').forEach((el) => {
      if (el !== this.mainDetailsToggle) {
        el.removeAttribute('open');
        const summary = el.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', false);
      }
    });
    this.mainDetailsToggle.setAttribute('open', true);
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  closeOnLeave() {
    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => this.close(), 80);
  }

  onDocumentClick(event) {
    if (!this.mainDetailsToggle.hasAttribute('open')) return;
    if (this.contains(event.target)) return;
    this.close();
  }

  onKeyDown(event) {
    if (event.key !== 'Escape') return;
    if (!this.mainDetailsToggle.hasAttribute('open')) return;
    this.close();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
